import React, { useState, useEffect } from 'react';
import BaseInformationParams from '../types/BaseInformationParams';
import getText from '../api/getText';

const TermsOfUseMain: React.FC = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const fetchText = async () => {
      const params: BaseInformationParams = {
        type: 'terms_of_use',
        name: 'for_customer'
      }

      try {
        const response = await getText(params);

        setText(response.data.text);
      } catch (error) {
        console.error("Error fetching terms of use data:", error);
      }
    };

    fetchText();
  }, []);

  return (
    <React.Fragment>
      <main id="page-facility_login" className="wrapper">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">ご利用規約</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <p className="c-txt__01 contact-box__txt" style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default TermsOfUseMain;
